module.exports = __webpack_public_path__ + "static/media/Command_Cluster_01.462bb3a9.jpg";